import Gobalstore from "../index";
export const actions = {
  getProvince: function (localStore) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "GET",
        url: `/admin/guarded/management/province/`,
      })
        .then(function (response) {
          localStore.commit("setProvince", response.data);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  createProvince: function (localStore, body) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "POST",
        url: `/admin/guarded/management/province/`,
        data: body,
      })
        .then(function (response) {
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  updateProvince: function (localStore, body) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "PUT",
        url: `/admin/guarded/management/province/`,
        data: body,
      })
        .then(function (response) {
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  deleteProvince: function (localStore, provId) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "DELETE",
        url: `/admin/guarded/management/province/${provId}`,
      })
        .then(function (response) {
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },
};
